module.exports = __webpack_public_path__ + "assets/img/poster-vip_01.0ba7a42e.jpg";